import React from 'react';
import c from 'classnames';

import { SearchResults } from '@uncinc/react-searchkit';
import type { Results } from '@uncinc/react-searchkit/types';

import type { ForumPostProps } from '../../Forum/Post';
import type { SearchForumThreadHit } from '../types';
import Hit from './Hit';

import './style.scss';

export interface SearchForumThreadResultsProps extends Omit<Results, 'renderItem'> {
  originalPosterId: number;
  onClickReply: ForumPostProps['onClickReply'];
}

const SearchForumThreadResults: React.FC<SearchForumThreadResultsProps> = (props) => {
  const { originalPosterId, onClickReply, emptyState } = props;

  const classNames = c('SearchForumThread__Results');

  return (
    <SearchResults
      className={classNames}
      emptyState={emptyState}
      renderItem={(hit: SearchForumThreadHit) => (
        <Hit
          hit={hit}
          originalPosterId={originalPosterId}
          onClickReply={onClickReply}
        />
      )}
    />
  );
};

export default SearchForumThreadResults;
